import { gql } from "@apollo/client";
import { DashboardItemOnProfileFragment } from "lib/types/graphql";

export const dashboardItemOnProfileGqlFragment = gql`
  fragment DashboardItemOnProfile on dashboards {
    id
    name
    slug
    created_at
    tags

    dashboard_favorite_count_all {
      favorite_count
    }

    trending_scores {
      score_1h
      score_4h
      score_24h
      updated_at
    }
  }
`;

export type DashboardOnProfileType = {
  id: number;
  name: string;
  slug: string;
  created_at: string;
  tags: string[];
  favoriteCount: number;
  isTrending: boolean;
};

/* Selector: Transform dashboard result fragment to more usable data structure */
export function toDashboardOnProfileType(
  dashboard: DashboardItemOnProfileFragment
): DashboardOnProfileType {
  return {
    id: dashboard.id,
    name: dashboard.name ?? "",
    slug: dashboard.slug,
    created_at: dashboard.created_at,
    tags: dashboard.tags ?? [],
    favoriteCount: dashboard.dashboard_favorite_count_all?.favorite_count ?? 0,
    isTrending:
      (dashboard.trending_scores?.score_1h ?? 0) >= 1 ||
      (dashboard.trending_scores?.score_4h ?? 0) >= 2 ||
      (dashboard.trending_scores?.score_24h ?? 0) >= 20,
  };
}
